import { getDocumentUrl } from './api'

/**
 * Юридические документы проекта ИП Гастамировой.
 *
 * Документы хранятся на общем docs-сервере, но ссылки этой копии принадлежат
 * только ИП Гастамировой и не должны переиспользовать документы других ИП.
 */
export const ANSARIT_LEGAL = {
    termsOfUse: {
        title: 'Пользовательское соглашение',
        url: getDocumentUrl('пользовательское_соглашение_для_сайта_ИП_Гастамирова_1.pdf'),
    },
    privacyPolicy: {
        title: 'Политика обработки персональных данных пользователей сайта',
        url: getDocumentUrl('20260811_ПОЛИТИКА_обработки_ПДН_пользователей_сайта_ГАСТАМИРОВА.pdf'),
    },
    privacyPolicyApprovalOrder: {
        title: 'Приказ об утверждении политики обработки персональных данных пользователей сайта',
        url: getDocumentUrl('20260811_ПРИКАЗ_об_утверждении_политики_ПДН_пользователей_сайта.pdf'),
    },
    consentPersonalData: {
        title: 'Согласие посетителя сайта на обработку персональных данных',
        url: getDocumentUrl('согласие_посетителя_сайта_на_обработку_ПДн_ИП_ГАСТАМИРО.pdf'),
    },
} as const

export type AnsaritLegalDocKey = keyof typeof ANSARIT_LEGAL
